export function getFlipAnimation (element, settings) {
    const flip = {};
    if (settings.withFade ?? true) {
        flip.opacity = 0
    }
    if(settings.flipDirection) {
        switch (settings.flipDirection) {
            case 'leftright':
                flip.rotationY = "180deg";
                break;
            case 'rightleft':
                flip.rotationY = "-180deg";
                break;
            case 'topdown':
                flip.rotationX = "180deg";
                break;
            case 'bottomup':
                flip.rotationX = "-180deg";
                break;
        }
    } else {
        //If no flipdirection is selected
        //Use this as the default direction
        flip.rotationX = "180deg";
    }

    return flip;
}
